import { createReducer, on } from '@ngrx/store';
import { initialCountryState } from './country.state';
import {
  loadCountry,
  loadCountrySuccess,
  loadCountryFailure,
} from './country.actions';

export const countryReducer = createReducer(
  initialCountryState,
  on(loadCountry, state => ({ ...state, isLoading: true })),
  on(loadCountrySuccess, (state, { countries }) => ({
    ...state,
    data: countries,
    isLoading: false,
  })),
  on(loadCountryFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false,
  }))
);
